const success = '#6aad40';
const warning = '#f7b500';
const error = '#b00020';
const extraPink = '#f36274';
const blue = '#38afd1';
export const colorRotation = [blue, success, warning, error, extraPink];
